import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { FilterComponentProp } from '../hocs/types'
import { SearchFiltersCheckboxes } from '../../components/search-filters-checkbox/search-filters-checkboxes'

const berthProps: FilterComponentProp = {
    title: 'Berth',
}

export const Berth = withFacetContext(
    FacetName.berth,
    withFilterContext(FilterName.berth, SearchFiltersCheckboxes, berthProps)
)
